import {
  AfterViewInit,
  Component,
  ElementRef,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ThemeProvider } from "@mui/material";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { Subscription } from "rxjs";
import { Chanels } from "../chanels";
import { EntityService } from "../entity/entity.service";
import { theme } from "../react-theme";
import { SignalsService } from "../signals/signals.service";
import { Guid } from "../system/guid";
import { ServiceBusService } from "../system/service-bus.service";
import Rooms from "./components/Rooms";
import "../react-components/i18n";
import { setAxiosInterceptors } from "../security/axiosInterceptors";
import axios from "axios";

const containerElementName = "myReactComponentContainer";

@Component({
  selector: "app-my-component",
  template: `<span #${containerElementName}></span>`,
  encapsulation: ViewEncapsulation.None,
})
export class RoomsReactComponent
  implements OnChanges, OnDestroy, AfterViewInit {
  @ViewChild(containerElementName, { static: true }) containerRef: ElementRef;

  siteId: Guid;

  public isLoadingEntities = true;

  private userSubscription: Subscription;

  private user: any;

  constructor(
    private bus: ServiceBusService,
    private entityService: EntityService,
    private signalsService: SignalsService,
  ) {
    setAxiosInterceptors(axios);
  }

  ngOnInit() {
    this.userSubscription = this.bus
      .chanelObservable(Chanels.USER_CHANEL)
      .subscribe((user) => {
        this.user = user;
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    ReactDOM.unmountComponentAtNode(this.containerRef.nativeElement);
  }

  private render() {
    ReactDOM.render(
      <ThemeProvider theme={theme}>
        <RoomsContext.Provider
          value={{
            user: this.user,
            entityService: this.entityService,
            signalsService: this.signalsService,
          }}
        >
          <Rooms />
        </RoomsContext.Provider>
      </ThemeProvider>,
      this.containerRef.nativeElement
    );
  }
}

type RoomContextTypes = {
  user: any;
  entityService: EntityService;
  signalsService: SignalsService;
};

export const RoomsContext = React.createContext<RoomContextTypes>(undefined);
